import React, { FC } from 'react';
import cm from 'classnames';

import { InputAlert } from './elements/input-alert';
import { InputHeader } from './elements/input-header';

import styles from './_input.module.scss';

interface Props {
  header?: string | React.ReactNode;
  error?: string;
  className?: string;
  children: React.ReactNode;
}

export const InputGroup: FC<Props> = ({ header, error, className, children }) => {
  const finalClassName = [styles.InputGroup];

  if (className) finalClassName.push(className);
  if (error) finalClassName.push(styles[`InputGroup--alert`]);

  return (
    <div className={cm(finalClassName)}>
      <InputHeader>{header}</InputHeader>
      {children}
      <InputAlert>{error}</InputAlert>
    </div>
  );
};

InputGroup.displayName = 'InputGroup';
